import { getConfiguration } from "./configuration";
import { loadLanguage } from "./loadLanguage";

export function getSeasonStatsUrl(seasonId, sportId) {
    const conf = getConfiguration(), lang = loadLanguage().toLowerCase();
    return conf.ps.clt.replace('{{lang}}', lang).replace('{{sportId}}', sportId).replace('{{seasonId}}', seasonId);
}
